module.exports = __webpack_public_path__ + "static/media/Extended_nats.com_2610x1044REV.15a1e43f.jpg";